<title>{{settings.HtmlTitle}}</title>
<div class="content">
  <ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true, primaryColour:'#63b5a2'}"></ngx-loading>

  <div style="display: none;" class="container search-sm">
    <div class="row">
      <div class="col-12">
        <div class="input-group">
          <input [(ngModel)]="searchText" type="text" class="form-control form-control-sm"
            placeholder="Taxnr, kenteken, VIN of merk">

          <button style="color:#d65d8a;" (click)="search()" class="btn btn-sm btn-secondary" type="button">
            <i class="fa fa-search" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="container container-biedingen">
    <h3>{{settings.Title}}</h3>
    @if (totalResults == null) {
    <p class="text-muted" style="font-size:12px;">Resultaten worden geladen...</p>
    }
    @if (settings.EnableAmoutOfResults && totalResults != null) {
    <p class="text-muted" style="font-size:12px;">Er
      zijn
      <b>{{totalResults}}</b> resultaten gevonden.
    </p>
    }

    <div style="display: none;" class="order-sm">
      <!-- Filtering Section -->
      @if (settings.EnableFiltering) {
      <div class="col-md-6 mb-2">
        <ng-select [clearable]="false" placeholder="Soort" [searchable]="false" (change)="setFilter($event)"
          [(ngModel)]="currentFilter" bindLabel="DisplayName" [compareWith]="compareFilters">
          @for (field of settings.FilteringFields; track field) {
          <ng-option disabled="false" [value]="field">{{field.DisplayName}}</ng-option>
          }
        </ng-select>
      </div>
      }

      <!-- Button Section -->
      <div class="col-md-6 mb-2">
        <div class="d-flex align-items-center">
          <!-- Ordering Button -->
          @if (settings.EnableOrdering) {
          <button class="btn btn-primary btn-sm w-auto me-2">
            <i (click)="setOrdering()" class="fa fa-sort" aria-hidden="true"></i>
          </button>
          }

          <!-- List View Button -->
          @if (settings.EnableListView) {
          <div class="w-auto me-2">
            @if (currentViewType == 'list') {
            <button class="btn btn-success btn-sm w-auto">
              <i (click)="setList()" class="fas fa-list-ul" aria-hidden="true"></i>
            </button>
            }
            @if (currentViewType != 'list') {
            <button class="btn btn-secondary btn-sm w-auto">
              <i (click)="setList()" class="fas fa-list-ul" aria-hidden="true"></i>
            </button>
            }
          </div>
          }

          <!-- Grid View Button -->
          @if (settings.EnableGridView) {
          <div class="w-auto">
            @if (currentViewType == 'grid') {
            <button class="btn btn-success btn-sm w-auto">
              <i (click)="setGrid()" class="fas fa-th" aria-hidden="true"></i>
            </button>
            }
            @if (currentViewType != 'grid') {
            <button class="btn btn-secondary btn-sm w-auto">
              <i (click)="setGrid()" class="fas fa-th" aria-hidden="true"></i>
            </button>
            }
          </div>
          }
        </div>
      </div>
    </div>

    <div class="search-lg">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            @if (settings.EnableFiltering) {
            <div class="col-md-6">
              <ng-select [clearable]="false" placeholder="Soort" (change)="setFilter($event)"
                [(ngModel)]="currentFilter" bindLabel="DisplayName" [compareWith]="compareFilters">
                @for (field of settings.FilteringFields; track field) {
                <ng-option [value]="field">
                  {{field.DisplayName}}</ng-option>
                }
              </ng-select>
            </div>
            }

            <!-- Button Section -->
            <div class="col-md-6 mb-2">
              <div class="d-flex align-items-center">
                <!-- Ordering Button -->
                @if (settings.EnableOrdering) {
                <button class="btn btn-primary btn-sm w-auto me-2">
                  <i (click)="setOrdering()" class="fa fa-sort" aria-hidden="true"></i>
                </button>
                }

                <!-- List View Button -->
                @if (settings.EnableListView) {
                <div class="w-auto me-2">
                  @if (currentViewType == 'list') {
                  <button class="btn btn-success btn-sm w-auto">
                    <i (click)="setList()" class="fas fa-list-ul" aria-hidden="true"></i>
                  </button>
                  }
                  @if (currentViewType != 'list') {
                  <button class="btn btn-secondary btn-sm w-auto">
                    <i (click)="setList()" class="fas fa-list-ul" aria-hidden="true"></i>
                  </button>
                  }
                </div>
                }

                <!-- Grid View Button -->
                @if (settings.EnableGridView) {
                <div class="w-auto">
                  @if (currentViewType == 'grid') {
                  <button class="btn btn-success btn-sm w-auto">
                    <i (click)="setGrid()" class="fas fa-th" aria-hidden="true"></i>
                  </button>
                  }
                  @if (currentViewType != 'grid') {
                  <button class="btn btn-secondary btn-sm w-auto">
                    <i (click)="setGrid()" class="fas fa-th" aria-hidden="true"></i>
                  </button>
                  }
                </div>
                }
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <div class="float-end">
                <div class="input-group">
                  <input style="width:210px;" (keyup.enter)="search()" [(ngModel)]="searchText" type="text"
                    class="form-control-sm form-control" placeholder="Taxnr, kenteken, VIN of merk">
                  <button style="background-color:#d65d8c" (click)="search()" class="btn btn-sm btn-secondary"
                    type="button">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Grid View -->
    @if (currentViewType == 'grid') {
    <div class="container">
      <div class="row">
        @if (valuations == '') {
        <p>
          <i class="far fa-frown"></i> Er zijn geen resultaten gevonden.
        </p>
        }
        @for (valuation of valuations; track valuation) {
        <div class="col-md-4" (click)="navigate(valuation.id, RouterLink)">
          <figure class="card card-product">
            <div class="img-wrap">
              @if (valuation.VehicleSpecification.Images) {
              <div>
                <img defaultImage="../../../assets/images/loading.gif" [offset]="50"
                  class="d-block img-fluid img-responsive" id="image"
                  [lazyLoad]="valuation.VehicleSpecification.Images['0'].imageUrl" />
              </div>
              }
              @if (!valuation.VehicleSpecification.Images) {
              <div>
                <img height="200" src="../../../assets/images/no-image-available_1.png">
              </div>
              }
            </div>
            <figcaption class="info-wrap">
              <h4 class="title" style="color:#63b5a2;">
                {{valuation.VehicleSpecification.Vehicle.make | capitalize}}
                {{valuation.VehicleSpecification.Vehicle.modelSpecific | capitalize}}
              </h4>
              <hr>
              <p class="desc" style="font-size: 13px;">
                <b>{{valuation.VehicleSpecification.Vehicle.registration | licensePipe:
                  valuation.VehicleSpecification.Vehicle.registration}}</b>
                | Bouwjaar: {{valuation.VehicleSpecification.Vehicle.year}}
                <br>
                <i class="fas fa-gas-pump"></i>
                @if (valuation.VehicleSpecification.FuelType == null) {
                <span>Onbekend </span>
                }
                @if (valuation.VehicleSpecification.FuelType != null) {
                <span>
                  {{valuation.VehicleSpecification.FuelType.descriptionNl
                  | capitalize}} </span>
                }|
                <i class="fas fa-tachometer-alt"></i>
                {{valuation.VehicleSpecification.mileage | number | replace:',':'.'}}
                {{valuation.VehicleSpecification.mileageType}}
                <br>
                <i class="fas fa-car"></i>
                @if (valuation.VehicleSpecification.BodyType == null) {
                <span>Onbekend</span>
                }
                @if (valuation.VehicleSpecification.BodyType != null) {
                <span>
                  {{valuation.VehicleSpecification.BodyType.descriptionNl
                  | capitalize}}</span>
                } |
                <i class="fas fa-gavel"></i>
                {{valuation.BidList.BidTerm.closeDateBid.date | date: 'dd-MM-yyyy'}}
              </p>
            </figcaption>
            <div class="bottom-wrap">
              <a class="btn btn-sm btn-primary float-end"
                style="color:white !important; background-color:#d65d8a;">Bekijk deze taxatie
                <i class="fas fa-chevron-right"></i>
              </a>
              <div class="price-wrap h6">
                @if (valuation.BidList.MyBid) {
                <div style="color:green; padding-top:5px;">Uw bod:
                  &euro;{{valuation.BidList.MyBid.bid | number:'1.0-0':'nl'}}</div>
                }
                @if (!valuation.BidList.MyBid) {
                <div style="color:red; font-size:11px;">Geen bieding door u
                  uitgebracht
                </div>
                }
              </div>
            </div>
          </figure>
        </div>
        }
      </div>
    </div>
    }

    <!-- List View -->
    @if (currentViewType == 'list') {
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            @for (field of settings.TableFields; track field) {
            <th (click)="field.EnableOrdering == true && setOrdering(field.orderField)">{{field.DisplayName}}
              @if (field.EnableOrdering && field.orderField != orderingField ) {
              <span><i class="fas fa-sort"></i></span>
              }
              @if (field.EnableOrdering && field.orderField == orderingField && currentOrderingDirection == 'ASC') {
              <span><i class="fas fa-sort-down"></i></span>
              }
              @if (field.EnableOrdering && field.orderField == orderingField && currentOrderingDirection == 'DESC') {
              <span><i class="fas fa-sort-up"></i></span>
              }
            </th>
            }
          </tr>
        </thead>
        <tbody>
          @if (valuations == '') {
          <td>
            <i class="far fa-frown"></i> Er zijn geen resultaten gevonden.
          </td>
          }
          @for (valuation of valuations; track valuation) {
          <tr (click)="navigate(valuation.id, RouterLink)">
            @for (row of settings.TableFields; track row) {
            <td>
              @switch (row.ApiField) {
              @case ('id') {
              <div>
                <b>T{{valuation.id}}</b>
              </div>
              }
              @case ('BidTermDate') {
              <div>
                @if ((valuation.BidList.BidTerm.closeDateBid.date | datedifference) == 0 ) {
                <div>
                  11:00
                </div>
                }
                @if ((valuation.BidList.BidTerm.closeDateBid.date | datedifference) >= 1 ) {
                <div>
                  {{valuation.BidList.BidTerm.closeDateBid.date | date: 'dd-MM-yyyy' }}
                </div>
                }
              </div>
              }
              @case ('VehicleMakeType') {
              <div>
                {{valuation.VehicleSpecification.Vehicle.make | capitalize}}
                {{valuation.VehicleSpecification.Vehicle.modelSpecific | capitalize}}
                {{valuation.VehicleSpecification.type | capitalize}}</div>
              }
              @case ('VehicleLicense') {
              <div>{{valuation.VehicleSpecification.Vehicle.registration |
                licensePipe:
                valuation.VehicleSpecification.Vehicle.registration }}
              </div>
              }
              @case ('VehicleYear') {
              <div>{{valuation.VehicleSpecification.Vehicle.year}}</div>
              }
              @case ('VehicleFuel') {
              <div>
                @if (valuation.VehicleSpecification.FuelType != null) {
                <div>
                  {{valuation.VehicleSpecification.FuelType.descriptionNl
                  | capitalize}}</div>
                }
                @if (valuation.VehicleSpecification.FuelType == null) {
                <div>Onbekend</div>
                }
              </div>
              }
              @case ('VehicleMileage') {
              <div>
                {{valuation.VehicleSpecification.mileage | number | replace:',':'.'}}</div>
              }
              @case ('VehicleBodyType') {
              <div>
                @if (valuation.VehicleSpecification.BodyType != null) {
                <div>
                  {{valuation.VehicleSpecification.BodyType.descriptionNl
                  | capitalize}}</div>
                }
                @if (!valuation.VehicleSpecification.BodyType == null) {
                <div>Onbekend</div>
                }
              </div>
              }
              @case ('BidMyBid') {
              <div>
                @if (valuation.BidList.MyBid) {
                <div>€ {{valuation.BidList.MyBid.bid | number:'2.0-0':'nl'}}
                </div>
                }
                @if (!valuation.BidList.MyBid) {
                <div>-</div>
                }
              </div>
              }
              @case ('BidHighestBid') {
              <div>
                @if (valuation.highestExpertBid) {
                <div>€
                  {{valuation.highestExpertBid | number:'2.0-0':'nl'}}</div>
                }
                @if (!valuation.highestExpertBid) {
                <div>-</div>
                }
              </div>
              }
              @case ('SaleFor') {
              <div>
                @if (valuation.assignedPrice) {
                <div>€ {{valuation.assignedPrice | number:'2.0-0':'nl'}}</div>
                }
                @if (!valuation.assignedPrice) {
                <div>-</div>
                }
              </div>
              }
              @case ('BoughtOn') {
              <div>
                @if (valuation.soldDate && valuation.soldPrice) {
                <div>
                  <div>{{valuation.soldDate.date | date: 'dd-MM-yyyy'}}</div>
                </div>
                }
                @if (!valuation.soldDate && !valuation.soldPrice && valuation.assignedDate) {
                <div>
                  <div>{{valuation.assignedDate.date | date: 'dd-MM-yyyy'}}</div>
                </div>
                }
                @if (!valuation.assignedDate && !valuation.soldDate ) {
                <div>
                  -
                </div>
                }
              </div>
              }
              @case ('BoughtFor') {
              <div>
                @if (valuation.soldDate && valuation.soldPrice) {
                <div>
                  <div>€ {{valuation.soldPrice | number:'1.0-0':'nl'}}</div>
                </div>
                }
                @if (!valuation.soldDate && !valuation.soldPrice) {
                <div>
                  <div>€ {{valuation.assignedPrice | number:'1.0-0':'nl'}}</div>
                </div>
                }
              </div>
              }
              @case ('BoughtVia') {
              <div>
                @if (valuation.soldDate && valuation.soldPrice) {
                <div>
                  <div>Te koop</div>
                </div>
                }
                @if (!valuation.soldDate && !valuation.soldPrice) {
                <div>
                  <div>Bieden</div>
                </div>
                }
              </div>
              }
              @case ('OriginCommercialType') {
              <div>{{valuation.OriginCommercialType.name | capitalize}}
              </div>
              }
              @case ('OriginChannelType') {
              <div>{{valuation.OriginChannelType.name | capitalize}}</div>
              }
              @case ('VehicleDeliveryDate') {
              <div>
                @if (valuation.dateDelivery) {
                <div>{{(valuation | dateDelivery).date | date: 'dd-MM-yyyy'}}
                </div>
                }
              </div>
              }
              @case ('VehicleState') {
              <div>
                @if (valuation.StatusType != null) {
                <div>{{valuation.StatusType.descriptionNl | capitalize}}
                </div>
                }
                @if (valuation.StatusType == null) {
                <div>Onbekend</div>
                }
              </div>
              }
              @case ('VehicleBoughtFor') {
              <div>
                @if (valuation.BidList.MyBid) {
                <div>€ {{valuation.BidList.MyBid.bid | number:'1.0-0':'nl'}}
                </div>
                }
                @if (!valuation.BidList.MyBid) {
                <div>-</div>
                }
              </div>
              }
              @case ('VehicleBoughtOn') {
              <div>
                @if (valuation.assignedDate) {
                <div>{{valuation.assignedDate.date | date: 'dd-MM-yyyy'}}
                </div>
                }
                @if (!valuation.assignedDate) {
                <div>Onbekend</div>
                }
              </div>
              }
              }
            </td>
            }
          </tr>
          }
        </tbody>
      </table>
    </div>
    }

    <!-- Pagination -->
    @if (totalPages > 1) {
    <div>
      <ul class="pagination pagination-sm justify-content-center">
        <li class="page-item" [ngClass]="{disabled:currentPage === 1}">
          <a class="page-link" (click)="setPage(1)">
            <i class="fa fa-fast-backward" aria-hidden="true"></i>
          </a>
        </li>
        <li class="page-item" [ngClass]="{disabled:currentPage === 1}">
          <a class="page-link" (click)="setPage(currentPage - 1)">
            <i class="fa fa-backward" aria-hidden="true"></i>
          </a>
        </li>
        <li class="page-item">
          <div class="dropdown">
            <button class="btn btn-sm btn-default dropdown-toggle" type="button" id="dropdownMenu1"
              data-bs-toggle="dropdown" aria-expanded="false">
              Pagina {{currentPage}} van {{totalPages}}
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
              <li>
                <input (keyup.enter)="navigateToPage()" [(ngModel)]="setPageNumber" type="number"
                  class="form-control form-control-sm" placeholder="Ga naar pagina...">
              </li>
            </ul>
          </div>
        </li>
        <li class="page-item" [ngClass]="{disabled:currentPage === totalPages}">
          <a class="page-link" (click)="setPage(currentPage + 1)">
            <i class="fa fa-forward" aria-hidden="true"></i>
          </a>
        </li>
        <li class="page-item" [ngClass]="{disabled:currentPage === totalPages}">
          <a class="page-link" (click)="setPage(totalPages)">
            <i class="fa fa-fast-forward" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
    }
  </div>
</div>